import queryClient from '../../../ReactQuery/client';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { put } from '../../../redux/api';

import { getCustomQueueQueryKey } from './useCustomProvidedBuildsQueue';

type UpdateCustomQueueParams = {
  name: string;
};

async function updateCustomQueue({ name }: UpdateCustomQueueParams): Promise<void> {
  await put('/api/organization/custom-provided-builds-queue', { name });
}

/**
 * Hook to update the custom provided builds queue for the current organization.
 * @returns Mutation function to update the custom queue
 */
export const useUpdateCustomProvidedBuildsQueue = () => {
  return useToastedMutation({
    mutationFn: updateCustomQueue,
    successToastMessage: 'Custom queue updated successfully',
    errorToastMessage: 'Failed to update custom queue',
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: getCustomQueueQueryKey() });
    },
  });
};
